import SelectOption from '@/store/dict/selectOptionDict'

export function configFun() {
  const validateRentPeriod = (rule, value, callback) => {
    const reg = /^(0|([1-9][0-9]{0,1}))$/g
    this.$refs.configSearchBox.validateFieldKeys('presentDays')
    if (!reg.test(value)) {
      callback(new Error('请输入有效的租赁周期'))
    } else if (this.rentPeriodType === 'input') {
      if (value < 1 || value > 60) {
        callback(new Error('租赁周期范围在1-60个月'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
  const validateBillDay = (rule, value, callback) => {
    const reg = /^(0|([1-9][0-9]{0,1}))$/g
    if (reg.test(value) && value > 0 && value < 32) {
      callback()
    } else {
      callback(new Error('请输入1-31区间的值'))
    }
  }
  const validatePresentDays = (rule, value, callback) => {
    const reg = /^(0|([1-9]\d*))$/g
    const { rentPeriod } = this.$refs.configSearchBox.formInline
    if (rentPeriod) {
      if (!reg.test(value) && value !== '') {
        callback(new Error('请输入有效的赠送天数'))
      } else if (value > 30 * rentPeriod) {
        callback(new Error('超出租赁周期，请重新填写'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
  const validatePrice = (rule, value, callback) => {
    const reg = /^(0|([1-9][0-9]{0,9}))(\.\d{0,2})?$/g
    if (reg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入有效的金额'))
    }
  }
  const configRules = {
    rentPeriod: [
      {
        required: true,
        message: '预计租赁周期不能为空',
        trigger: ['change', 'blur'],
      },
      {
        validator: this.validateRentPeriod,
        trigger: ['change', 'blur'],
      },
    ],
    billDay: [
      { required: true, message: '请输入缴款日', trigger: 'blur' },
      {
        validator: this.validateBillDay,
        message: '请输入1-31区间的值',
        trigger: ['change', 'blur'],
      },
    ],
    presentDays: [
      {
        validator: this.validatePresentDays,
      },
    ],
    rentAmount: [
      { required: true, message: '请输入', trigger: 'blur' },
      { validator: this.validatePrice },
    ],
    deposit: [
      { required: true, message: '请输入', trigger: 'blur' },
      { validator: this.validatePrice },
    ],
    rentCalculationRules: [{ required: true }],
    payFormName: [{ required: true }],
    payTypeName: [{ required: true }],
    billDayName: [{ required: true }],
  }
  const baseRules = {
    name: [{ required: true, message: '请输入', trigger: 'blur' }],
    brandId: [{ required: true, message: '请选择', trigger: 'change' }],
    modelId: [{ required: true, message: '请选择', trigger: 'change' }],
    cityCodes: [{ required: true, message: '请选择城市', trigger: 'change' }],
  }
  const rentPeriodMode = {
    input: {
      type: 'input',
      label: '预计租赁周期',
      key: 'rentPeriod',
      options: {
        maxlength: 20,
        type: 'number',
        max: 60,
        placeholder: '请输入预计租赁周期',
        clearable: true,
        append: '个月',
        ref: 'rentPeriod',
        change_s: this.rentPeriodChange,
        btnConfig: {
          text: '下拉选月',
          attrs: {
            class: 'rentPeriodBtn',
            type: 'text',
            icon: 'el-icon-edit',
            size: 'small',
          },
          clickFn: () => this.changeRentPeriod(1, 'select', 'noInit'),
        },
      },
    },
    select: {
      type: 'select',
      label: '预计租赁周期',
      key: 'rentPeriod',
      source: SelectOption.leasingSchemeByStages,
      options: {
        clearable: true,
        ref: 'rentPeriod',
        change_s: this.rentPeriodChange,
        btnConfig: {
          text: '自定义选月',
          attrs: {
            class: 'rentPeriodBtn',
            type: 'text',
            icon: 'el-icon-edit',
            size: 'small',
          },
          clickFn: () => this.changeRentPeriod(1, 'input', 'noInit'),
        },
      },
    },
  }
  const configDefaultValue = {
    rentCalculationRules: '自定义',
    payFormName: '分期支付',
    payTypeName: '按月预付',
    billDayName: '31号（按自然月为计租周期）',
  }
  return {
    validateRentPeriod,
    validateBillDay,
    validatePresentDays,
    validatePrice,
    configRules,
    baseRules,
    rentPeriodMode,
    configDefaultValue,
  }
}
